// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import BootstrapVue from 'bootstrap-vue';
import VeeValidate, { Validator } from 'vee-validate';
import Breadcrumb from '@/components/Breadcrumb';
import Notification from 'vue-notification';
import VueMoment from 'vue-moment';
import Vuetify from 'vuetify';
import VueMask from 'v-mask';
import Vue2Filters from 'vue2-filters'


// include theme styles
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'dialog-polyfill/dialog-polyfill.css';
import '@/assets/css/vue-multiselect.min.css';

import App from './App';
import store from './store';
import router from './router';
import granted from './helpers/grantedDirective';
import RouteTab from './components/RouteTab';
import { dictionary, validations } from './validations';
import apolloProvider from './apollo';

Vue.config.productionTip = process.env.NODE_ENV === 'production';

Vue.use(Vuetify, {
  iconfont: 'md' // 'md' || 'mdi' || 'fa' || 'fa4'
});

Vue.use(BootstrapVue);

Vue.use(VeeValidate, {
  events: 'input|submit',
  dictionary,
});

Object.keys(validations).forEach(name => {
  Validator.extend(name, validations[name]);
});

Vue.use(Notification);

Vue.component('breadcrumbs', Breadcrumb);
Vue.component('reoute-tab', RouteTab);

Vue.directive('granted', granted);

Vue.use(VueMask);

Vue.use(Vue2Filters);

// sync the router with the vuex store.
// this registers `store.state.route`
sync(store, router);

Vue.use(VueMoment);

// register custom filters
Vue.filter('date', timestamp => {
  const date = new Date(timestamp);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
});

Vue.filter('thumb', (imageUrl, height, width) => {
  return imageUrl.replace('/image/upload/', `/image/upload/c_thumb,g_face,h_${height},w_${width}/`);
});


// Vue.filter('currency', ({balance, amount, currency}, locales = 'en-US') => {
//   const number = balance || amount;
//   if (number === undefined) {
//     return '';
//   }
//   if (currency === undefined) {
//     return number;
//   }
//   return new Intl.NumberFormat(locales, { style: 'currency', currency }).format(number);
// });

store.dispatch('checkAuth');
store.dispatch('checkWhiteLabel');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  provide: apolloProvider.provide(),
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js